export default "__VITE_ASSET__Ux8PG72W__"